import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { Button } from '@src/components/ui/button/button';
import { DateInput } from '@src/components/ui/react-hook-form/date-input/date-input';
import { Form } from '@src/components/ui/react-hook-form/form/form';
import { SubmitButton } from '@src/components/ui/react-hook-form/submit-button/submit-button';
import { TimeInput } from '@src/components/ui/react-hook-form/time-input/time-input';
import { cn } from '@src/utils/ui';
import React from 'react';
import { RESCHEDULE_VALIDATOR } from './validators';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import moment from 'moment';

export const RescheduleForm = ({ onSubmit, detail, ...props }) => {
    return (
        <Dialog {...props} className='tw-px-[24px] tw-py-[16px]'>
            <Form
                className='tw-space-[12px]'
                onSubmit={onSubmit}
                defaultValues={{
                    orderDate: moment.unix(detail.orderDate),
                    startTime: moment().startOf('day'),
                    // MKTPLC-353: end time is optional; default to null so it is only
                    // submitted (as ToDateTime) when the user actually selects one.
                    endTime: null
                }}
                validator={{ schema: RESCHEDULE_VALIDATOR }}
            >
                <DialogContent>
                    <FormContent detail={detail} />
                </DialogContent>
                <DialogActions className='tw-p-[8px] tw-flex tw-justify-end'>
                    <Button className={cn('tw-p-[8px] tw-text-[14px]')} variant='text' onClick={props.onClose}>
                        Cancel
                    </Button>
                    <SubmitButton className={cn('tw-p-[8px] tw-text-[14px]')} autoFocus variant='contained'>
                        Save
                    </SubmitButton>
                </DialogActions>
            </Form>
        </Dialog>
    );
};

function FormContent({ detail }) {
    const { trigger, getValues } = useFormContext();

    const handleDateChange = () => {
        const values = getValues();
        const timer = setTimeout(() => {
            trigger(
                Object.entries(values).reduce((arr, entry) => {
                    if (entry[1]) arr.push(entry[0]);
                    return arr;
                }, [])
            );
            clearTimeout(timer);
        }, 0);
    };

    return (
        <div className='tw-flex tw-flex-col tw-gap-[16px] tw-text-[16px] tw-text-bcaa-grey-900'>
            <div>
                <h6 className='tw-text-[20px] tw-font-medium'>Reschedule Task</h6>
                <p>You can only select a date within 30 days of the first payment.</p>
            </div>
            <div>
                <b className='tw-font-medium'>Select Date</b>
                <DateInput
                    name='date'
                    variant='outlined'
                    className='tw-w-full'
                    disablePast
                    maxDate={moment
                        .unix(detail.orderDate)
                        .add(30, 'days')
                        .endOf('day')}
                    InputProps={{
                        className: 'tw-text-[16px]'
                    }}
                    onChange={handleDateChange}
                />
            </div>

            <div>
                <b className='tw-font-medium'>Select Start Time</b>
                <TimeInput
                    name='startTime'
                    variant='outlined'
                    className='tw-w-full'
                    InputProps={{
                        className: 'tw-text-[16px]',
                        placeholder: '12:00 AM'
                    }}
                    onChange={handleDateChange}
                />
            </div>

            <div>
                <b className='tw-font-medium'>Select End Time (optional)</b>
                <TimeInput
                    name='endTime'
                    variant='outlined'
                    className='tw-w-full'
                    InputProps={{
                        className: 'tw-text-[16px]',
                        placeholder: '12:00 AM'
                    }}
                    onChange={handleDateChange}
                />
            </div>
        </div>
    );
}

RescheduleForm.propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    detail: PropTypes.shape({
        orderDate: PropTypes.string.isRequired
    }).isRequired
};

FormContent.propTypes = RescheduleForm.propTypes;
